<template>
  <div class="standart-radio">
    <span class="title">{{title}}</span>
    <div class="variants">
      <div class="variant" v-for="variant in variants" :key="variant">
        <input
            :name="name" :value="variant.value" :id="variant.id" type="radio"
            @change="radio_change(variant)"
            :checked="current_variant.value == variant.value"
        >
        <label :for="variant.id">{{variant.title}}</label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name : "StandartRadio",
  props : {
    title : String,
    name : String,
    variants : Object,
    current_variant: Object
  },
  data() {
    return{

    }
  },
  methods: {
    radio_change : function(e) {
      this.$emit("radio_change", e);
    }
  }
}
</script>

<style scoped>
.standart-radio {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.standart-radio .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  cursor: pointer;
  padding-left: 20px;
}

.standart-radio .variants {
  display: flex;
  gap: 22px;
  align-items: center;
  padding: 15px 20px;
}

.standart-radio .variant {
  gap: 8px;
  display: flex;
  align-items: center;
}

.standart-radio .variant label {
  cursor: pointer;
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.standart-radio input[type="radio"] {
  width: 20px;
  height: 20px;
  margin: 0px;
  cursor: pointer;
}

</style>